<script setup lang="ts">
import { isAjaxLoading } from '@/services/http';
</script>

<template>
  <div v-if="isAjaxLoading" class="ajax-loader" role="status" aria-live="polite">
    <span class="ajax-loader__bar" />
    <span class="ajax-loader__sr">Loading…</span>
  </div>
</template>

<style scoped>
.ajax-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 9999;
  pointer-events: none;
}
.ajax-loader__bar {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #2563eb, #38bdf8);
  animation: ajax-loader-slide 1.2s linear infinite;
}
.ajax-loader__sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
@keyframes ajax-loader-slide {
  from { transform: translateX(-100%); }
  to { transform: translateX(100%); }
}
</style>
